import React, { useState } from "react";
import NavigationMenu from "./NavigationMenu";
import { FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getStoredSuperAdminTarget, isSuperAdminViewing, exitSuperAdminView } from "../utils/superAdminView";

const DashboardLayout = ({ title, children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const viewing = isSuperAdminViewing();
  const target = viewing ? getStoredSuperAdminTarget() : null;

  return (
    <div className="flex min-h-screen">
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        {viewing && target && (
          <div className="border-b border-blue-200 bg-blue-50 px-4 py-2.5 shadow-sm">
            <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-3">
              <div className="min-w-0">
                <span className="font-semibold text-blue-800">Super Admin View:</span>{" "}
                <span className="text-blue-900 font-medium">{target.name || "Selected User"}</span>
                <span className="text-blue-700 text-sm ml-2 capitalize">({target.role})</span>
                <span className="hidden sm:inline text-blue-600 text-xs ml-2">Full access • mapped user view</span>
              </div>
              <button
                type="button"
                onClick={() => { exitSuperAdminView(); navigate("/admin-dashboard", { replace: true }); }}
                className="shrink-0 rounded-md bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 text-sm font-semibold"
              >
                Exit User View
              </button>
            </div>
          </div>
        )}
        <header className="bg-white shadow-sm sticky top-0 z-20 p-4">
          <div className="flex items-center justify-between gap-4">
            <button className="md:hidden text-gray-800" onClick={() => setMenuOpen(true)}>
              <FaBars size={20} />
            </button>
            <h1 className="text-xl font-bold text-gray-800 text-center flex-grow">{title}</h1>
            <div className="md:hidden w-8"></div>
          </div>
        </header>
        <main className="flex-1 overflow-auto">
          <div className="p-4 md:p-6 max-w-screen-2xl mx-auto w-full">
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
